import ComplianceNav from './ComplianceNav';

export { type ComplianceNavProps } from './ComplianceNav';
export default ComplianceNav;
